// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import Hardeman from '../../../Texas/data/counties/Hardeman.geo.json'
import Wilbarger from '../../../Texas/data/counties/Wilbarger.geo.json'
import Wichita from '../../../Texas/data/counties/Wichita.geo.json'
import Clay from '../../../Texas/data/counties/Clay.geo.json'
import Montague from '../../../Texas/data/counties/Montague.geo.json'
import Foard from '../../../Texas/data/counties/Foard.geo.json'
import Baylor from '../../../Texas/data/counties/Baylor.geo.json'
import Archer from '../../../Texas/data/counties/Archer.geo.json'
import Young from '../../../Texas/data/counties/Young.geo.json'
import Jack from '../../../Texas/data/counties/Jack.geo.json'

const counties = {
  Hardeman,
  Wilbarger,
  Wichita,
  Clay,
  Montague,
  Foard,
  Baylor,
  Archer,
  Young,
  Jack
}

export default counties
